import { Navigate, useLocation, useParams } from "react-router-dom";
import { BseSupplierView } from "./BseSupplierView";
import { v1SupplierViewLinkToV2 } from "./v1SupplierViewLinkToV2";

export const BseSupplierViewRoute = () => {
  const { eventId } = useParams();
  const location = useLocation();

  if (eventId) {
    return <Navigate to={v1SupplierViewLinkToV2(eventId, location.search)} replace />;
  }

  return <BseSupplierView />;
};
